import React from "react";
import Header from "./Header";
import Quizes from "./Quizes";

const Home = () => {
  return (
    <div>
      <Header></Header>
      <Quizes></Quizes>
    </div>
  );
};

export default Home;
